import { render, staticRenderFns } from "./AuthFormContainer.vue?vue&type=template&id=5185c065&"
import script from "./AuthFormContainer.vue?vue&type=script&lang=js&"
export * from "./AuthFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./AuthFormContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports